package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.InstagramSimpleIcons: ImageVector
    get() {
        if (_instagramSimpleIcons != null) {
            return _instagramSimpleIcons!!
        }
        _instagramSimpleIcons = Builder(name = "InstagramSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(7.03f, 0.08f)
                curveToRelative(-1.28f, 0.06f, -2.15f, 0.26f, -2.91f, 0.56f)
                curveToRelative(-0.79f, 0.31f, -1.46f, 0.72f, -2.12f, 1.39f)
                curveToRelative(-0.67f, 0.67f, -1.08f, 1.34f, -1.38f, 2.13f)
                curveToRelative(-0.30f, 0.76f, -0.50f, 1.64f, -0.55f, 2.91f)
                curveToRelative(-0.06f, 1.28f, -0.07f, 1.69f, -0.06f, 4.95f)
                curveToRelative(0.01f, 3.26f, 0.02f, 3.67f, 0.08f, 4.95f)
                curveToRelative(0.06f, 1.28f, 0.26f, 2.15f, 0.56f, 2.91f)
                curveToRelative(0.31f, 0.79f, 0.72f, 1.46f, 1.39f, 2.12f)
                curveToRelative(0.67f, 0.67f, 1.34f, 1.07f, 2.13f, 1.38f)
                curveToRelative(0.76f, 0.30f, 1.64f, 0.50f, 2.91f, 0.55f)
                curveToRelative(1.28f, 0.06f, 1.69f, 0.07f, 4.95f, 0.06f)
                curveToRelative(3.26f, -0.01f, 3.67f, -0.02f, 4.95f, -0.08f)
                curveToRelative(1.28f, -0.06f, 2.15f, -0.27f, 2.91f, -0.56f)
                curveToRelative(0.79f, -0.31f, 1.46f, -0.72f, 2.12f, -1.39f)
                curveToRelative(0.67f, -0.67f, 1.07f, -1.34f, 1.38f, -2.13f)
                curveToRelative(0.30f, -0.76f, 0.50f, -1.64f, 0.55f, -2.91f)
                curveToRelative(0.06f, -1.28f, 0.07f, -1.69f, 0.06f, -4.95f)
                curveToRelative(-0.01f, -3.26f, -0.02f, -3.67f, -0.08f, -4.95f)
                curveToRelative(-0.06f, -1.28f, -0.26f, -2.15f, -0.56f, -2.91f)
                curveToRelative(-0.31f, -0.79f, -0.72f, -1.46f, -1.39f, -2.12f)
                curveTo(21.30f, 1.33f, 20.63f, 0.92f, 19.84f, 0.62f)
                curveTo(19.07f, 0.32f, 18.20f, 0.12f, 16.92f, 0.06f)
                curveTo(15.65f, 0.01f, 15.24f, -0.01f, 11.98f, 0.00f)
                curveTo(8.72f, 0.01f, 8.31f, 0.02f, 7.03f, 0.08f)
                moveToRelative(0.14f, 21.69f)
                curveToRelative(-1.17f, -0.05f, -1.81f, -0.25f, -2.23f, -0.41f)
                curveToRelative(-0.56f, -0.22f, -0.96f, -0.48f, -1.38f, -0.90f)
                curveToRelative(-0.42f, -0.42f, -0.68f, -0.82f, -0.9f, -1.38f)
                curveToRelative(-0.16f, -0.42f, -0.36f, -1.06f, -0.42f, -2.23f)
                curveToRelative(-0.06f, -1.27f, -0.07f, -1.64f, -0.08f, -4.85f)
                curveToRelative(-0.01f, -3.20f, 0.01f, -3.58f, 0.06f, -4.85f)
                curveToRelative(0.05f, -1.17f, 0.25f, -1.81f, 0.41f, -2.23f)
                curveToRelative(0.22f, -0.56f, 0.48f, -0.96f, 0.90f, -1.38f)
                curveToRelative(0.42f, -0.42f, 0.82f, -0.68f, 1.38f, -0.9f)
                curveToRelative(0.42f, -0.17f, 1.06f, -0.36f, 2.23f, -0.42f)
                curveToRelative(1.27f, -0.06f, 1.65f, -0.07f, 4.85f, -0.08f)
                curveToRelative(3.20f, -0.01f, 3.58f, 0.01f, 4.85f, 0.06f)
                curveToRelative(1.17f, 0.05f, 1.81f, 0.24f, 2.23f, 0.41f)
                curveToRelative(0.56f, 0.22f, 0.96f, 0.48f, 1.38f, 0.90f)
                curveToRelative(0.42f, 0.42f, 0.68f, 0.82f, 0.9f, 1.38f)
                curveToRelative(0.17f, 0.42f, 0.36f, 1.06f, 0.42f, 2.23f)
                curveToRelative(0.06f, 1.27f, 0.07f, 1.65f, 0.08f, 4.85f)
                curveToRelative(0.01f, 3.20f, -0.01f, 3.58f, -0.06f, 4.85f)
                curveToRelative(-0.05f, 1.17f, -0.25f, 1.81f, -0.41f, 2.23f)
                curveToRelative(-0.22f, 0.56f, -0.48f, 0.96f, -0.90f, 1.38f)
                curveToRelative(-0.42f, 0.42f, -0.82f, 0.68f, -1.38f, 0.9f)
                curveToRelative(-0.42f, 0.17f, -1.06f, 0.36f, -2.23f, 0.42f)
                curveToRelative(-1.27f, 0.06f, -1.65f, 0.07f, -4.85f, 0.08f)
                curveToRelative(-3.20f, 0.01f, -3.58f, -0.01f, -4.85f, -0.06f)
                moveTo(16.95f, 5.59f)
                arcTo(1.44f, 1.44f, 0.0f, true, false, 18.39f, 4.14f)
                arcToRelative(1.44f, 1.44f, 0.0f, false, false, -1.44f, 1.44f)
                moveTo(5.84f, 12.01f)
                curveToRelative(0.01f, 3.40f, 2.77f, 6.16f, 6.17f, 6.15f)
                curveToRelative(3.40f, -0.01f, 6.16f, -2.77f, 6.15f, -6.17f)
                curveToRelative(-0.01f, -3.40f, -2.77f, -6.16f, -6.17f, -6.15f)
                curveToRelative(-3.40f, 0.01f, -6.16f, 2.77f, -6.15f, 6.17f)
                moveTo(8.0f, 12.01f)
                arcToRelative(4.0f, 4.0f, 0.0f, true, true, 4.01f, 3.99f)
                arcTo(4.0f, 4.0f, 0.0f, false, true, 8.0f, 12.01f)
            }
        }
        .build()
        return _instagramSimpleIcons!!
    }

private var _instagramSimpleIcons: ImageVector? = null
